import axios from 'axios';

export const schedulingService = {
  async getAppointments(params = {}) {
    try {
      const response = await axios.get('/appointments', { params, timeout: 15000 });
      return response.data.appointments || response.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },

  async getAppointmentById(id) {
    try {
      const response = await axios.get(`/appointments/${id}`);
      return response.data.appointment || response.data;
    } catch (error) {
      console.error('Error fetching appointment:', error);
      throw error;
    }
  },

  async updateAppointmentStatus(id, status, reason = null) {
    try {
      const response = await axios.patch(`/appointments/${id}/status`, {
        status,
        reason,
      });
      return response.data.appointment || response.data;
    } catch (error) {
      console.error('Error updating appointment status:', error);
      throw error;
    }
  },

  async restoreAppointment(id) {
    try {
      const response = await axios.post(`/appointments/${id}/restore`);
      return response.data.appointment || response.data;
    } catch (error) {
      console.error('Error restoring appointment:', error);
      throw error;
    }
  },

  // Statistics endpoint (optional)
  async getAppointmentStats() {
    try {
      const response = await axios.get('/appointments/stats');
      return response.data.stats || response.data;
    } catch (error) {
      console.error('Error fetching appointment stats:', error);
      throw error;
    }
  },
};
